export default __webpack_public_path__ + "static/media/brand-ambassador.c776809f.webp";